import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  dispatcherheader:{
    padding: "10px", 
    background: "#fff", 
    boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
    position: 'absolute',
    top: 0
  },
  // Pill-style button styles
  pillButton: {
    borderRadius: "25px !important",
    textTransform: "none !important",
    padding: "8px 20px !important",
    fontWeight: 500,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  },
  activeButton: {
    // background: "#30e356 !important",
    color: "#fff !important",
  },
  offlineButton: {
    // background: "#f44336 !important",
    color: "#fff !important",
  },
  ridingButton: {
    // background: "#0472e2 !important",
    color: "#fff !important",
  },
  dashboardButton: {
    background: "#ff41b4 !important",
    color: "#fff !important",
  },
}));

export default useStyles;
